import {COLOR} from "src/service/constant/color"
import React, { useState} from "react"
import {LetterTab, LetterTabItem, LetterWrap} from "src/styles/views/UserPage/letter"
import {useNavigate} from "react-router-dom"
import LetterHealth from "src/component/UserPage/Letter/LetterHealth"
import {useLocation} from "react-router"
import LetterLife from "src/component/UserPage/Letter/LetterLife"

const tabList = [
    {idx: 0, text: '헬스', path: 'health'},
    {idx: 1, text: '라이프', path: 'life'}
]
const UserPageLetter = () => {
    const {pathname} = useLocation()
    const [tabData, setTabData] = useState(pathname?.indexOf("health") >= 0 ? 0 : 1)
    const navigate = useNavigate()


    return (
        <LetterWrap>
            <LetterTab>
                {tabList?.map((option: { idx: number, text: string, path: string }) => (
                    <LetterTabItem
                        color={option.idx === tabData ? COLOR.black : COLOR.blueGray2} key={option.idx}
                        onClick={ () => {
                            navigate(`/userPage/letter/${option?.path}`)
                            setTabData(option.idx)
                        }}
                    >
                        {option.text}
                    </LetterTabItem>
                ))}
            </LetterTab>
            {pathname?.indexOf("health") >= 0 ? <LetterHealth/> : <LetterLife/>}
        </LetterWrap>
    )
}
export default UserPageLetter